import { createSlotRecipe } from './runtime.js';

const marqueeConfig = {"name":"marquee","slots":["root","track"],"defaultVariants":{"pauseOnHover":false,"reverse":false,"vertical":false},"variantMap":{"pauseOnHover":["false","true"],"reverse":["false","true"],"vertical":["false","true"]}}

export const marquee = /* @__PURE__ */ createSlotRecipe(marqueeConfig)